import styled from 'styled-components';

const DialogHeader = styled.span`
	color: ${(props) => props.theme.colors.lightBlue};
	display: inline-block;
	font: ${(props) => props.theme.font.title};
	font-size: 10.4vmin;
	left: 4%;
	overflow: hidden;
	position: absolute;
	right: 4%;
	top: 16%;
	text-overflow: ellipsis;
	transform: rotate(-10deg);
	transform-origin: top left;
	white-space: pre-wrap;

	&:first-letter {
		text-transform: uppercase;
	}
`;

const Highlight = styled.strong`
	color: ${(props) => props.theme.colors.veryLightBlue};
	font-size: 135%;
`;

export default DialogHeader;
export { Highlight };
